import { render, staticRenderFns } from "./component-e505c56b.vue?vue&type=template&id=684d1241&scoped=true&"
import script from "./component-e505c56b.vue?vue&type=script&lang=js&"
export * from "./component-e505c56b.vue?vue&type=script&lang=js&"
import style0 from "./component-e505c56b.vue?vue&type=style&index=0&id=684d1241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d1241",
  null
  
)

export default component.exports